module.exports = __webpack_public_path__ + "static/enterprise_collaboration-5bb0811f4f959092c4ffb80beba5ed39.jpg";